import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { useCallback, useRef, useState } from '@redneckz/uni-jsx/lib/hooks';
import { useOutsideClick } from '@redneckz/uni-jsx/lib/hooks/useOutsideClick';
import { BlockWrapper } from '../../ui-kit/BlockWrapper.js';
import { useDialogManager } from '../../ui-kit/DialogManager/useDialogManager.js';
import { UniBlock } from '../../UniBlock/UniBlock.js';
import { StickyBottomMenuItem } from './StickyBottomMenuItem.js';
import { useBottomMenuItemDialog } from './useBottomMenuItemDialog.js';
import { useBurgerMenuDialog } from './useBurgerMenuDialog.js';
const EMPTY_MENU = [];
export const StickyBottomMenu = UniBlock(({ sticky, ...rest }) => {
    const { menuItems = EMPTY_MENU } = sticky ?? {};
    const centralMenuItem = menuItems.find((_) => _.title === 'Меню');
    const lateralMenuItems = menuItems.filter((_) => _.title !== 'Меню');
    const middleIdx = Math.floor(lateralMenuItems.length / 2);
    const leftItems = lateralMenuItems.slice(0, middleIdx);
    const rightItems = lateralMenuItems.slice(middleIdx);
    const [activeIndex, setActiveIndex] = useState(-1);
    const [currentItemPosition, setCurrentItemPosition] = useState('');
    const { open: openDialog, closeAll } = useDialogManager();
    const closeDialog = useCallback(() => {
        setActiveIndex(-1);
        setCurrentItemPosition('');
        closeAll();
    }, [closeAll]);
    const dialogRef = useOutsideClick(closeDialog);
    const menuRef = useRef(null);
    const [isBurgerMenuDialogOpen, { toggle }] = useBurgerMenuDialog({
        menuRef,
        centralMenuItem,
        closeAll,
        openDialog,
        locationDialogProps: rest.header,
    });
    const [{ openBottomMenuItemDialog }] = useBottomMenuItemDialog({
        menuRef,
        dialogRef,
        closeDialog,
        openDialog,
        leftItems,
        rightItems,
    });
    const handleMenuBurgerClick = useCallback((e) => {
        closeDialog();
        e.stopPropagation();
        toggle();
    }, [closeDialog, toggle]);
    const handleMenuItemClick = useCallback((index, itemsPosition) => {
        setCurrentItemPosition(itemsPosition);
        setActiveIndex(index);
        closeAll();
        openBottomMenuItemDialog(index, itemsPosition);
    }, [closeAll, openBottomMenuItemDialog]);
    return (_jsx(BlockWrapper, { className: "h-[74px] z-[100] relative", defaultPadding: "p-0", ...rest, children: _jsxs("div", { ref: menuRef, className: "ml-auto container bg-white flex justify-center shadow-blue-gray", children: [leftItems.map(renderMenuItem(handleMenuItemClick, 'left', { activeIndex, currentItemPosition })), _jsx(StickyBottomMenuItem, { item: centralMenuItem, isActive: isBurgerMenuDialogOpen, onClick: (e) => handleMenuBurgerClick(e) }), rightItems.map(renderMenuItem(handleMenuItemClick, 'right', { activeIndex, currentItemPosition }))] }) }));
});
const renderMenuItem = (onClick, itemsPosition, currentActiveItem) => (_, i, arr) => {
    return (_jsx(StickyBottomMenuItem, { item: _, isActive: arr[currentActiveItem.activeIndex]?.title === _?.title &&
            currentActiveItem.currentItemPosition === itemsPosition, onClick: (e) => {
            if (!(arr[currentActiveItem.activeIndex]?.title === _?.title &&
                currentActiveItem.currentItemPosition === itemsPosition)) {
                e.stopPropagation();
            }
            onClick(i, itemsPosition);
        } }, _.title || String(i)));
};
//# sourceMappingURL=StickyBottomMenu.js.map